module.exports = __webpack_public_path__ + "img/zhu_xc14.bf930714.jpg";